import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=2431dbc7"
var script = {}
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=2431dbc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports